module.exports = "data:image/gif;base64,R0lGODlhAQBaAMQAAMZlBMdmBMdpCMZmBMlqCMRhBMVkBMpwCMpsCMRgBMtwCMlsCMZkBMtuCMViBMlrCMhpCMdoCMpvCOzs7MtvCMpuCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAAAAAAALAAAAAABAFoAAAUx4CSOZGWelaRSbMsq8HGotNTcbYNWCLL8i4fwQYAYjYKIUhkYAACMKMNgcFgdhUQiBAA7"


//////////////////
// WEBPACK FOOTER
// ./src/images/tail-bottom.gif
// module id = 282
// module chunks = 0